<template>
  <w-icon-wrapper icon-name='work-settings-icon'>
    <g
      id='_8_Einstellungen_Icon'
      data-name='8 Einstellungen_Icon'
      transform='translate(0 -0.5)'
    >
      <path
        id='Pfad_55652'
        d='M23,3H8.85a3.495,3.495,0,0,0-6.7,0H1A1,1,0,0,0,1,5H2.15a3.495,3.495,0,0,0,6.7,0H23a1,1,0,0,0,0-2ZM6.61,5A1.494,1.494,0,1,1,4.39,3,1.494,1.494,0,1,1,6.61,5Z'
        data-name='Pfad 55652'
        fill='currentColor'
      />
      <g
        id='Gruppe_25428'
        data-name='Gruppe 25428'
      >
        <path
          id='Pfad_55653'
          d='M23,20H14.85a3.495,3.495,0,0,0-6.7,0H1a1,1,0,0,0,0,2H8.15a3.495,3.495,0,0,0,6.7,0H23a1,1,0,0,0,0-2ZM12.61,22A1.477,1.477,0,1,1,13,21,1.467,1.467,0,0,1,12.61,22Z'
          data-name='Pfad 55653'
          fill='currentColor'
        />
      </g>
      <g
        id='Gruppe_25429'
        data-name='Gruppe 25429'
      >
        <path
          id='Pfad_55654'
          d='M23,10.62H20.85a3.495,3.495,0,0,0-6.7,0H1a1,1,0,0,0,0,2H14.15a3.495,3.495,0,0,0,6.7,0H23a1,1,0,0,0,0-2Zm-4.39,2a1.5,1.5,0,0,1-2.61-1,1.487,1.487,0,0,1,.39-1,1.482,1.482,0,0,1,2.22,0,1.487,1.487,0,0,1,.39,1A1.468,1.468,0,0,1,18.61,12.62Z'
          data-name='Pfad 55654'
          fill='currentColor'
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconSettings' };
</script>
